<script>
export default {
  props: {
    label:  { type: String, default: 'Selecionar arquivo' },
    accept: { type: String, default: '*' },
    value:  { type: String, default: '' },
    hint:   { type: String, default: '' },
    maxMb:  { type: Number, default: 10 },
  },
  data() {
    return { dragging: false }
  },
  methods: {
    onFileChange(e) {
      const file = e.target.files[0]
      if (!file) return
      this.validarEmitir(file)
      // Limpa o input para permitir novo upload do mesmo arquivo
      e.target.value = ''
    },
    onDrop(e) {
      this.dragging = false
      const file = e.dataTransfer.files[0]
      if (!file) return
      this.validarEmitir(file)
    },
    validarEmitir(file) {
      if (file.size > this.maxMb * 1024 * 1024) {
        this.$toast.error(`Arquivo muito grande. Máximo ${this.maxMb}MB.`)
        return
      }
      this.$emit('change', file)
    },
    remover() {
      this.$emit('remover')
    },
    abrir() {
      if (!this.value) {
        this.$refs.input.click()
      }
    },
  },
}
</script>

<template>
  <div>
    <div
      class="upload-zone rounded p-4"
      :class="{
        'text-center': !value,
        'text-left': !!value,
        'border border-success': !!value,
        'border-primary': dragging && !value,
      }"
      :style="{
        border: value ? '2px solid #34C392' : (dragging ? '2px solid #0F3396' : '2px dashed #d1d1e3'),
        backgroundColor: value ? '#f0fdf8' : (dragging ? '#eef1fd' : 'transparent'),
        cursor: value ? 'default' : 'pointer',
        transition: 'all .2s',
        minHeight: '120px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: value ? 'flex-start' : 'center',
      }"
      @click="abrir"
      @dragover.prevent="dragging = true"
      @dragleave.prevent="dragging = false"
      @drop.prevent="onDrop"
    >
      <input ref="input" type="file" :accept="accept" class="d-none" @change="onFileChange" />

      <div v-if="!value" class="w-100">
        <i class="bx bx-cloud-upload font-size-24 text-muted mb-2 d-block"></i>
        <p class="mb-1 font-weight-semibold font-size-14">{{ label }}</p>
        <p v-if="hint" class="font-size-12 text-muted mb-1">{{ hint }}</p>
      </div>

      <div v-else class="w-100 d-flex align-items-center" style="min-width: 0" @click.stop>
        <i class="bx bx-file text-success font-size-22 mr-2 flex-shrink-0"></i>
        <span
          class="font-size-13 font-weight-semibold text-truncate flex-fill"
          style="min-width: 0"
          :title="value"
        >{{ value }}</span>
        <button
          type="button"
          class="btn btn-sm btn-soft-danger ml-3 flex-shrink-0 d-inline-flex align-items-center"
          @click.stop="remover"
        >
          <i class="bx bx-trash mr-1"></i> Remover
        </button>
      </div>
    </div>
  </div>
</template>
